import { CurrencyModel } from "@spa/api";
import {SelectOptionInterface} from 'appShared/components';
import {UnspecifiedKeysEnum} from "appShared/enums";

export class CurrencyTrait {
    static getSortedCurrencyAsOptions(
        currencies: CurrencyModel[],
        addAllOption: boolean = false,
    ): SelectOptionInterface[] {
        const options: SelectOptionInterface[] = [];
        if (addAllOption) {
            options.push({
                label: 'All',
                value: UnspecifiedKeysEnum.UnspecifiedCurrencyKey
            });
        }
        options.push(...currencies
            .filter((c: CurrencyModel) => c.isTradeAvailable)
            .sort((n1, n2) => n1.currencyCode.localeCompare(n2.currencyCode))
            .sort(
                (n1, n2) =>
                    Number(n2.isDefaultForTrade) - Number(n1.isDefaultForTrade)
            )
            .map((c: CurrencyModel): SelectOptionInterface => {
                return {
                    label: c.currencyCode,
                    value: c.currencyCode,
                };
            }));

        return options;

    }
    static getCurrenciesAsOptions(currencies: string[], defaultCurrencies: CurrencyModel[]): SelectOptionInterface[] {
        const merged =  CurrencyTrait.mergeDynamicCurrenciesWithDefaults(currencies, defaultCurrencies);

        return merged
            .sort((n1, n2) => n1.currencyCode.localeCompare(n2.currencyCode))
            .sort(
                (n1, n2) =>
                    Number(n2.isDefaultForTrade) - Number(n1.isDefaultForTrade)
            )
            .map((c: CurrencyModel): SelectOptionInterface => {
                return {
                    label: c.currencyCode,
                    value: c.currencyCode,
                };
            });
    }
    static mergeDynamicCurrenciesWithDefaults(currencies: string[], defaultCurrencies: CurrencyModel[]): CurrencyModel[] {
        const models = currencies.map(currency => new CurrencyModel({
            currency_code : currency.toUpperCase(),
            is_default_for_trade: false,
            is_trade_available: true
        })) ?? [];
        const merged = models.map(model => {
            return defaultCurrencies.find(currency => currency.currencyCode == model.currencyCode) ?? model;
        });

        return merged;
    }

}
